import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { useFormContext } from '../Form';
import useRegisterInput from '../Form/useRegisterInput';

const ObjectField = ({ name, label, fields, value, onChange, register: shouldRegister }) => {
  useRegisterInput(name, shouldRegister);

  const formContext = useFormContext();
  const { setValue } = formContext || {};

  const handleChange = field => (ev, newValue) => {
    if (formContext && !onChange) {
      setValue(name, newValue);
      return;
    }

    if (onChange) {
      onChange(ev, { ...value, [field]: newValue });
    }
  };

  return (
    <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
      <FormLabel component="legend">{label ?? name}</FormLabel>
      {fields.map(({ InputComponent, inputProps, name: subName }) => (
        <InputComponent
          {...inputProps}
          key={`schema_field_${name}_${subName}`}
          name={`${name}.${subName}`}
          value={value?.[subName]}
          onChange={handleChange(subName)}
          register={false}
        />
      ))}
    </FormControl>
  );
};

ObjectField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func,
  label: PropTypes.string,
  fields: PropTypes.array,
  register: PropTypes.bool,
};

ObjectField.defaultProps = {
  label: undefined,
  fields: [],
  value: undefined,
  onChange: undefined,
  register: true,
};

export default ObjectField;
